import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from './../../../../../environments/environment';
import { ServiceCRUD } from './../../../../shared/crud/ServiceCRUD';

@Injectable()
export class TipoDealerService
extends ServiceCRUD {
  private baseUrlService: string;

  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.baseUrlService = environment.URL_API
  }

  protected getURL(): string {
    return `${this.baseUrlService}/tipo_dealer`
  }

}
